<template>
  <router-link
    :to="{name: 'player_resource_log_copy', params: {playerId: playerId, copyId: copyId}}"
  >
    {{lable}} {{copyId}}
  </router-link>
</template>

<script>
export default {
  name: 'PlayerResourceLogCopyLink',

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    copyId: {
      type: Number,
      required: true,
    },

    lable: {
      type: String,
      default: 'Copy'
    }
  },
};
</script>
